import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import { NavLink } from "react-router-dom";
import "./navbar.css";
import { Col, Container, Row } from "react-bootstrap";
const Navigationbar = () => {
  const [show, setShow] = useState("top");
  const [lastScrollY, setLastScrolly] = useState(0);
  const [isNavOpen, setIsNavOpen] = useState(false);

  const controlNav = () => {
    if (window.scrollY > 200) {
      if (window.scrollY > lastScrollY) {
        setShow("hide");
      } else {
        setShow("show");
      }
      setLastScrolly(window.scrollY);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", controlNav);

    return () => {
      window.removeEventListener("scroll", controlNav);
    };
  }, [lastScrollY]);

  const handleNavToggle = (isOpen) => {
    setIsNavOpen(isOpen);
  };

  return (
    <>
      <Navbar
        data-bs-theme="dark"
        className={`fixed-top custom_navbar ${show}`}
        expand="sm"
        onToggle={handleNavToggle}
      >
        <Navbar.Brand className="d-flex">
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
           <Link to="/home">
              <img
                src="/assets/images/newlogo1.png"
                alt="Logo"
                className={`icon-logo responsive-logo ${
                  isNavOpen ? "responsive-logo-top" : "responsive-logo-not-top"
                }`}
              />
            </Link>
            <div>
              <img
                src='/assets/images/newlogotext1.png'
                alt=""
                className={`icon-logo-text responsive-text-logo ${
                  isNavOpen
                    ? "responsive-text-logo-top"
                    : "responsive-text-logo-not-top"
                }`}
              />
            </div>
          </div>
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="my-nav" />
        <Navbar.Collapse id="my-nav">
          <Nav className="justify-content-end" style={{ width: "100%" }}>
            <NavLink className="nav-link navbar-header" to="/home">
              Home
            </NavLink>
            <NavLink className="nav-link" to="/about">
              About
            </NavLink>
            <NavLink className="nav-link" to="/services">
              Services
            </NavLink>
            <NavLink className="nav-link navbar-footer" to="/contact">
              Contact Us
            </NavLink>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    </>
  );
};

export default Navigationbar;
